import { render, staticRenderFns } from "./punishmentset.vue?vue&type=template&id=d583a676&"
import script from "./punishmentset.vue?vue&type=script&lang=js&"
export * from "./punishmentset.vue?vue&type=script&lang=js&"
import style0 from "./punishmentset.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports